.headerMenu {
  width: 100%;

  :global {
    .ant-menu-item::after,
    .ant-menu-submenu::after,
    .ant-menu-item:hover::after,
    .ant-menu-submenu:hover::after {
      display: none
    }

    .ant-menu-item-selected::after,
    .ant-menu-submenu-selected::after,
    .ant-menu-item-selected:hover::after,
    .ant-menu-submenu-selected:hover::after {
      display: block;
      margin: 0 -16px;
    }

    .ant-menu-item-selected::after,
    .ant-menu-submenu-selected::after {
      border-image: var(--bc-selected-menu-item-border-color, var(--bc-menu-horizontal-item-selected-color)) 1;
    }
  }
}

.centered {
  justify-content: center;
}
